// extracted by mini-css-extract-plugin
export default {"scrollContainer":"F1eiaq","native":"OyWI_4","draggable":"_awUY_","controlling":"StATsX","clickCatcher":"FiOQS6","catch":"bXeQwJ","content":"b8u8Pu"};